<template>
  <div class="container-fluid">
    <!-- 其他Title顯示 -->
    <h6 class="mt-4 mb-2" v-if="checkTableTitle">
      與<truncate-tool :content="tableTitle"></truncate-tool> 相關的保單
      <span>(僅顯示您的經手件及服務件) </span>
    </h6>
    <!-- 原Title顯示 -->
    <h4 class="mt-4 mb-2" v-else>{{ tableTitle }}</h4>
    <div class="row">
      <table
        :id="prefix"
        class="table datatable"
        :class="
          options.color === 'green' ? 'insurance-green' : 'insurance-blue'
        "
      >
        <thead>
          <tr>
            <th
              v-for="(item, index) in options.columns"
              :key="`table-tr-${index}`"
              :width="item.width || '*'"
              :class="{
                sorting: item.sorting,
                sorting_asc: item.sorting && order.index == index && order.asc,
                sorting_desc:
                  item.sorting && order.index == index && !order.asc,
                'text-right': item.align && item.align === 'right'
              }"
              @click="item.sorting ? columnSorting(item.name, index) : false"
            >
              <span v-html="item.label"></span>
            </th>
          </tr>
        </thead>
        <tbody
          v-for="(insure, i) in tableData"
          :key="`${prefix}-${i}`"
          :id="`${prefix}-tr-${i}`"
        >
          <!-- 國泰壽險保單主約 -->
          <tr v-show="insure.prod_cat == 1">
            <td
              v-for="(col, cid) in options.columns"
              :class="{ 'text-right': col.align && col.align === 'right' }"
              :width="col.width || '*'"
              :key="`${prefix}-col-${cid}`"
              :style="
                (insure.child.length ? 'border-bottom:0;' : '') +
                (options.columns.length - 1 === cid
                  ? 'border-right:1px solid #C2C4C7'
                  : '')
              "
              style="border-top: 0"
            >
              <span v-if="col.name == 'cebnfMap' && insure.cebnfMap">
                <template v-for="(cebnf, cebnf_index) in insure.cebnfMap">
                  <span :key="`cebnfMap_${cebnf_index}`" style="display: block">
                    {{ getCebnfName(cebnf_index) }} : {{ cebnf }}
                  </span>
                </template>
              </span>
              <span
                v-else-if="
                  prefix === 'cathay-insure' && col.name === 'policy_no'
                "
              >
                <a
                  v-if="!modalLoading && !insure.isSelfIns"
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                >
                  {{ insure.no }}
                </a>
                <a
                  v-else-if="!modalLoading && insure.isSelfIns"
                  class="text-deepblue"
                >
                  {{ insure.no }}
                </a>
                <span v-else>{{ insure.no }}</span>
                <div
                  :class="{ 'section-loading': modalLoading }"
                  class="d-inline-block"
                  style="height: 20px; width: 30px"
                ></div>
                <span class="text-red">{{ insure.scrt_ind }}</span>
                <br />
                {{ insure.name }}
                <span>({{ insure.prod_id }})</span>
              </span>
              <span
                v-else-if="
                  prefix === 'other-insure' && col.name === 'policy_no'
                "
              >
                <small>{{ insure.company }} / {{ insure.policynumber }}</small>
                <br />
                {{ insure.product }}
              </span>
              <span v-else-if="col.truncate_tool"
                ><truncate-tool
                  :content="col.truncate_tool(insure)"
                ></truncate-tool
              ></span>
              <span
                v-else-if="col.template"
                v-html="col.template(insure)"
              ></span>
              <span
                v-else-if="
                  col.click &&
                  prefix === 'cathay-insure' &&
                  col.name === 'target'
                "
              >
                <a
                  v-if="
                    insure.target_id &&
                    insure.target_id !== '' &&
                    insure.dataInsdExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                >
                  {{ insure[col.name] }}
                </a>
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="
                  col.click &&
                  prefix === 'cathay-insure' &&
                  col.name === 'client'
                "
              >
                <a
                  v-if="
                    insure.clientId &&
                    insure.clientId !== '' &&
                    insure.dataAcpExist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                >
                  {{ insure[col.name] }}
                </a>
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="
                  col.click &&
                  prefix === 'other-insure' &&
                  col.name === 'applicant'
                "
              >
                <a
                  v-if="insure.target_id && insure.target_id !== ''"
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                >
                  {{ insure[col.name] }}
                </a>
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <span
                v-else-if="
                  col.click &&
                  prefix === 'other-insure' &&
                  col.name === 'fullname'
                "
              >
                <a
                  v-if="
                    insure.personalid &&
                    insure.personalid !== '' &&
                    insure.dataexist == true
                  "
                  @click="col.click(insure, cid)"
                  class="link text-underline"
                >
                  {{ insure[col.name] }}
                </a>
                <span v-else>{{ insure[col.name] }}</span>
              </span>
              <a
                v-else-if="col.click && insure.dataexist == true"
                @click="col.click(insure, cid)"
                class="link text-underline"
              >
                {{ insure[col.name] }}
              </a>
              <span v-else>{{ insure[col.name] }}</span>
            </td>
            <td v-if="isEdit">
              <div class="dropdown" v-if="DeleteBtn == false">
                <a
                  :id="`${prefix}-${i}-dropdown`"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  v-if="insure.relatedtoprimaryinsured == '本人'"
                  aria-expanded="false"
                  class="btn btn-icon btn-default btn-sm"
                  role="button"
                >
                  <i class="icon-more"></i>
                </a>
                <div
                  class="dropdown-menu"
                  :aria-labelledby="`${prefix}-${i}-dropdown`"
                >
                  <a
                    role="button"
                    @click="$emit('call', 'openInsureForm', 2, false, insure)"
                    class="dropdown-item text-green text-underline"
                  >
                    修改
                  </a>
                  <a
                    @click="
                      $emit('call', 'confirmClearInsurance', insure, true)
                    "
                    class="dropdown-item text-green text-underline"
                  >
                    刪除
                  </a>
                  <a
                    @click="$emit('call', 'openInsureForm', 6, true, insure)"
                    class="dropdown-item text-green text-underline"
                  >
                    新增附約
                  </a>
                </div>
              </div>
              <div v-else class="text-center">
                <a
                  v-if="!insure.isSelfIns"
                  class="dropdown-item text-green text-underline"
                ></a>
                <a
                  v-else
                  @click="$emit('call', 'confirmCathayInsurance', insure, true)"
                  class="text-red text-underline"
                >
                  刪除
                </a>
              </div>
            </td>
          </tr>

          <!-- 國泰壽險保單附約 -->
          <tr
            v-show="insure.child && insure.child.length"
            class="child-table show"
          >
            <td :colspan="options.columns.length + 1" style="border: 0">
              <table class="table child">
                <tr
                  v-for="(child, chid_index) in insure.child"
                  :key="`${prefix}-tr-child-${chid_index}`"
                >
                  <td
                    v-for="(col, cid) in options.columns"
                    :class="{
                      'text-right': col.align && col.align === 'right',
                      childMV: cid === 0 && !col.customize
                    }"
                    style="
                      border-top: 0;
                      border-right: 1px dotted #c2c4c7;
                      border-bottom: 1px dotted #c2c4c7;
                    "
                    :width="col.width || '*'"
                    :key="`${prefix}-col-${cid}`"
                    :style="
                      options.columns.length - 1 === cid ? 'border-right:0' : ''
                    "
                  >
                    <slot :name="col.name" :data="col">
                      <span v-if="col.name == 'cebnfMap'">
                        <template
                          v-for="(cebnf, cebnf_index) in child.cebnfMap"
                        >
                          <span
                            :key="`cebnfMap_${cebnf_index}`"
                            style="display: block"
                          >
                            {{ getCebnfName(cebnf_index) }} : {{ cebnf }}
                          </span>
                        </template>
                      </span>
                      <span
                        v-else-if="col.template"
                        v-html="col.template(child)"
                      ></span>
                      <span v-else-if="col.name != 'policy_no'">
                        {{ child[col.name] }}
                      </span></slot
                    >
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- 國泰壽險沒有主約的附約 -->
          <!-- <tr class="child-table show onlySub" v-if="insure.onlySubIns">
            <td :colspan="options.columns.length + 1">
              <table class="table child">
                <tr>
                  <td
                    v-for="(col, cid) in options.columns"
                    :class="{
                      'text-right': col.align && col.align === 'right',
                      'sub-child': cid === 0
                    }"
                    :width="getClientWidth(i, cid)"
                    :key="`${prefix}-sub-col-${cid}`"
                  >
                    <span
                      v-if="prefix === 'cathay-insure' && col.name === 'policy_no'"
                    >
                      <span>{{ insure.no }}</span>
                      <br />
                      <div class="pl-4 inline-block">{{ insure.name }}</div>
                    </span>

                    <span
                      v-else-if="col.template"
                      v-html="col.template(insure)"
                    ></span>
                    <span
                      v-else-if="
                        col.click &&
                          prefix === 'cathay-insure' &&
                          col.name === 'target'
                      "
                    >
                      <a
                        v-if="insure.target_id && insure.target_id !== ''"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                      >
                        {{ insure[col.name] }}
                      </a>
                      <span v-else>{{ insure[col.name] }}</span>
                    </span>
                    <span
                      v-else-if="
                        col.click &&
                          prefix === 'cathay-insure' &&
                          col.name === 'client'
                      "
                    >
                      <a
                        v-if="insure.clientId && insure.clientId !== ''"
                        @click="col.click(insure, cid)"
                        class="link text-underline"
                      >
                        {{ insure[col.name] }}
                      </a>
                      <span v-else>{{ insure[col.name] }}</span>
                    </span>
                    <a
                      v-else-if="col.click"
                      @click="col.click(insure, cid)"
                      class="link text-underline"
                    >
                      {{ insure[col.name] }}
                    </a>
                    <span
                      v-else-if="col.template"
                      v-html="col.template(child)"
                    ></span>
                    <span v-else>{{ insure[col.name] }}</span>
                  </td>
                  <td width="56"></td>
                </tr>
              </table>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool";

export default {
  name: "DataTable",
  mixins: [commonMixin],
  components: {
    TruncateTool
  },
  props: {
    collapse: {
      type: Boolean,
      default: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "green"
    },
    prefix: {
      type: String,
      default: ""
    },
    tableTitle: {
      type: String,
      default: ""
    },
    currentPage: {
      type: Number,
      default: 0
    },
    totalpages: {
      type: Number,
      default: 0
    },
    scrollDataLoading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    options: {
      type: Object,
      default: () => {
        return null;
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modalLoading: {
      type: Boolean,
      default: false
    },
    DeleteBtn: {
      type: Boolean,
      default: false
    },
    checkPersonalId: {
      type: Boolean,
      default: false
    },
    checkTableTitle: {
      type: Boolean,
      default: false
    },
    initSort: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    baseLink() {
      return `${window.location.origin}${window.location.pathname}`;
    }
  },
  data() {
    return {
      checkFirst: true,
      tableList: this.tableData,
      order: {
        index_default: 0,
        asc_default: true,
        index: 0,
        asc: true
      },
      remoteDataMsg: "資料讀取中，請稍候...",
      currentWidth: 0,
      childStatus: [],
      cebnfkdNameMap: {
        1: "年金受益人",
        2: "滿期金受益人",
        3: "身故受益人",
        4: "祝壽金受益人"
      } //受益人種類 cebnfkd 代碼對
    };
  },
  watch: {
    tableData: "initData",
    collapse: "toggleAll"
  },
  methods: {
    //受益人種類中文轉換
    getCebnfName(val) {
      return this.cebnfkdNameMap[val];
    },

    getClientWidth(i, index) {
      if (!this.childStatus.length) return;

      let $th = Array.from(this.$el.querySelectorAll("th"));
      // console.log(this.$el, $th[index], $th[index].clientWidth)
      // debugger
      return $th[index].clientWidth;
    },
    initData() {
      if (this.initSort) {
        this.order.index = this.order.index_default;
        this.order.asc = this.order.asc_default;
      }

      this.tableData.forEach((insure, i) => {
        this.childStatus[i] = {
          render: false,
          show: false
        };
      });

      if (this.checkFirst == true) {
        this.checkFirst = false;
        if (this.options.defaultSort) {
          let indexO = 0;
          let asc =
            this.options.defaultSort.asc === false
              ? (asc = this.options.defaultSort.asc)
              : true;

          for (let index = 0; index < this.options.columns.length; index++) {
            let item = this.options.columns[index];
            if (item.name === this.options.defaultSort.colName) {
              indexO = index;
              break;
            }
          }

          this.order.index_default = indexO;
          this.order.asc_default = asc;

          this.order.index = indexO;
          this.order.asc = asc;

          if (this.options.defaultSort.doSort !== false) {
            setTimeout(() => {
              this.columnSorting(this.options.defaultSort.colName, indexO, asc);
              this.registerHanlink();
              return;
            }, 150);
          }
        }
      }

      this.registerHanlink();
    },
    toggleAll(val) {
      this.tableData.forEach((insure, i) => {
        if (this.childStatus[i].show !== val) this.toggleChild(insure, i);
      });
    },
    toggleChild(insure, i) {
      this.childStatus[i].show = !this.childStatus[i].show;
      this.$forceUpdate();
    },
    columnSorting(colName, index, asc) {
      // 資料排序
      if (this.order.index === index) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.index = index;
        this.order.asc = true;
      }

      if (asc !== undefined) {
        this.order.asc = asc;
      }

      this.options.sorting(colName, this.order.asc);
    }
  }
};
</script>

<style lang="scss" scoped>
tr.child > td {
  padding: 0;
}
</style>
